import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[maxNumber][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxNumberDirective, multi: true }]
})

export class MaxNumberDirective implements Validator, OnChanges {
    @Input() maxNumber: number;

    onChange: () => void;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.maxNumber && this.onChange) {
            this.onChange();
        }
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onChange = fn;
    }

    validate(c: FormControl): { [key: string]: any } {
        const v = c.value;
        return (this.maxNumber === null
            || this.maxNumber === undefined
            || Number(v) > Number(this.maxNumber))
            ? { maxNumber: true }
            : null;
    }
}
